import request from '../../utils/request';

export function signIn(params) {
  return request('/auth/login', {
    method: 'POST',
    data: params,
  });
}

export function signUp(params) {
  return request('/auth/register', {
    method: 'POST',
    data: params,
  });
}

export function adminSignIn(params) {
  return request('/auth/admin-login', {
    method: 'POST',
    data: params,
  });
}

export function getProfile() {
  return request('/auth/profile', {
    method: 'GET',
  });
}

export function changePassword(params) {
  return request('/auth/change-password', {
    method: 'POST',
    data: params,
  });
}
